import { useContext, useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import classes from '../../../styles/AllDevices.module.css';
import { LoaderContext } from "../../../context/LoaderContext";
import { START_LOADER, STOP_LOADER } from "../../../constants";
import { EventsService } from "../../../services/EventsService";
import { momentTimeFormater } from "../../../utils/dateHelper";
import Typography from "../../../components/Typography/Typography";
import CustomTooltip from "../../../components/CustomToolTip/CustomTooltip";
import { UilFileLandscapeAlt, UilInfoCircle, UilLightbulbAlt, UilSync } from '@iconscout/react-unicons';
import ModalComponent from "../../../components/ModalComponent/ModalComponent";
import DataLogModal from "./DataLogModal";
import CommandLogsModal from "./CommandLogsModal";

import myClasses from '../../SmartCharging/SmartCharging.module.css';
import EventsLogModal from "./EventsLogModal";

const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);

const CurrentEvents = ({ }) => {
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });
    const [events, setEvents] = useState([]);
    const [eventsLogModal, setEventsLogModal] = useState({ status: false, id: '' });
    const [commandLogModal, setCommandLogModal] = useState({ status: false, id: '' });
    const [dataLogModal, setDataLogModal] = useState({ status: false, data: '' });

    useEffect(() => {
        getEvents();
    }, []);

    const getEvents = () => {
        EventsService.GetCurrentEvents(
            () => startLoader('getEvents'),
            handleGetEventsSuccess,
            handleError,
            () => stopLoader('getEvents')
        );
    };

    const handleError = (err) => {
        console.log(err);
    };

    const handleGetEventsSuccess = ({ data }) => {
        const processedData = data?.data?.data?.map((item, index) => {
            return {
                's.no': index + 1,
                instanceName: item.instanceName,
                edgeId: item.edgeId,
                status: item.status,
                SOC: item.soc || '--',
                startTime: item.startTime ? momentTimeFormater(item.startTime).format('YYYY-MM-DD HH:mm:ss') : '--',
                endTime: item.endTime ? momentTimeFormater(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '--',
                action: (
                    <div className={myClasses.ActionIcons}>
                        <div onClick={() => {
                            setEventsLogModal({
                                status: true,
                                id: item._id,
                            });
                        }}>
                            <CustomTooltip content={'Event Logs'}>
                                <UilFileLandscapeAlt size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                        <div onClick={() => {
                            setCommandLogModal({
                                status: true,
                                id: item._id,
                            });
                        }}>
                            <CustomTooltip content={'Command Logs'}>
                                <UilLightbulbAlt size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                        <div onClick={() => setDataLogModal({ status: true, data: item })}>
                            <CustomTooltip content={'Data Log'}>
                                <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                    </div>
                )
            };
        });
        setEvents(processedData);
    };

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <div className={classes.Alert}>
                <div className={myClasses.wholeFilterWrapper}>
                    <div className={myClasses.HeadingContainer}>
                        <Typography content={`Current`} />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={events.length} />
                            </span>
                        </div>
                    </div>
                    <CustomTooltip content={'Refresh'}>
                        <div className={classes.Action} onClick={() => getEvents()}>
                            <div>
                                <UilSync size={'1.2vw'} style={{ color: 'var(--color-primary)', cursor: 'pointer' }} />
                            </div>
                        </div>
                    </CustomTooltip>
                </div>
                <Table
                    head={[
                        'Instance',
                        'Edge ID',
                        'Status',
                        'SOC',
                        'Start Time (CET)',
                        'End Time (CET)',
                        'Actions'
                    ]}
                    keys={[
                        'instanceName',
                        'edgeId',
                        'status',
                        'SOC',
                        'startTime',
                        'endTime',
                        'action'
                    ]}
                    data={events}
                />
            </div>
            <ModalComponent isOpen={eventsLogModal.status} setOpen={() => setEventsLogModal({
                status: false,
                id: '',
            })}>
                <EventsLogModal setOpen={() => setEventsLogModal({ status: false, id: '' })} id={eventsLogModal.id} />
            </ModalComponent>
            <ModalComponent isOpen={commandLogModal.status} setOpen={() => setCommandLogModal({
                status: false,
                id: '',
            })}>
                <CommandLogsModal setOpen={() => setCommandLogModal({ status: false, id: '' })} id={commandLogModal.id} />
            </ModalComponent>
            <ModalComponent isOpen={dataLogModal.status} setOpen={() => setDataLogModal({
                status: false,
                data: '',
            })}>
                <DataLogModal setOpen={() => setDataLogModal({ status: false, data: '' })} data={dataLogModal.data} />
            </ModalComponent>
        </div>
    )
}

export default CurrentEvents;
